import { useParams } from 'react-router-dom';
import { useLoaderData } from 'react-router-dom';

import TestInfo from '../components/Tests/TestInfo';
import { getTableForm } from '../utils/api';

const TestDetail = () => {
    const urlParams = useParams();
	const tableForm=useLoaderData();
    return <TestInfo testID={urlParams.testID} page={urlParams.page} tableForm= {tableForm}/>;
};

export default TestDetail;

export  async function loader() {
    const response = await getTableForm('DTC:Patient','TestDetail');
	const resData = await response;
		return resData;
}